<template>
  <div>
    <!-- YOUR PUBLICATIONS -->
    <details>
      <summary><em>Your Publications</em></summary>
      <table class="table table-hover">
        <thead class="blue-gradient white-text">
        <tr>
          <th scope="col"><em><b>ID</b></em></th>
          <th scope="col"><em><b>THEME</b></em></th>
          <th scope="col"><em><b>PROJECT</b></em></th>
          <th scope="col"><em><b>TITLE</b></em></th>
          <th scope="col"><em><b>CO AUTHORS</b></em></th>
          <th scope="col"><em><b>ACTIONS</b></em></th>
        </tr>
        </thead>
        <tbody>
        <tr :key="publication.id" v-for="(publication, index) in response.publications">
          <td> {{ index + 1 }}</td>
          <td v-if="publication.theme"> {{ publication.theme }}</td>
          <td v-else> N/A</td>
          <td v-if="publication.project"> {{ publication.project }}</td>
          <td v-else> N/A</td>
          <td v-if="publication.title"> {{ publication.title }}</td>
          <td v-else> N/A</td>
          <td v-if="publication.co_authors"> {{ publication.co_authors }}</td>
          <td v-else> N/A</td>
          &nbsp; <b-icon
              @click="viewMyPublication(publication)"
              class="border border-info rounded"
              :font-scale="`${font_scale}`" icon="eye-fill"
              title="View"
              v-b-modal.modal-publication
              v-b-tooltip.hover variant="info"
          ></b-icon>
          &nbsp;
          &nbsp; <b-icon :title="`Update ${ publication.title }`"
                  @click="updatePublication(publication)"
                  class="border border-info rounded" :font-scale="`${font_scale}`"
                  icon="pencil" v-b-modal.modal-publication-edit
                  v-b-tooltip.hover
                  variant="info"
          ></b-icon>
          &nbsp;
          &nbsp; <b-icon
              @click="downloadPublication(publication.title)"
              class="border border-info rounded" :font-scale="`${font_scale}`"
              icon="download" title="Download"
              v-b-tooltip.hover variant="info"
          ></b-icon>
          &nbsp;
          &nbsp; <b-icon
              @click="deletePublication(publication.title)"
              class="border rounded bg-danger p-1"
              :font-scale="`${font_scale}`" icon="trash"
              title="Delete" v-b-tooltip.hover
              variant="light"
          ></b-icon>
        </tr>
        </tbody>
      </table>

      <!-- PUBLICATION MODALS -->
      <b-modal
          id="modal-publication"
          title="About Publication"
          v-model="showPubModalView"
      >
        <p><em>Title:</em> {{ publication.title }}</p>
        <p><em>Theme:</em> {{ publication.theme }}</p>
        <p><em>Project:</em> {{ publication.project }}</p>
        <p><em>Author:</em> {{ response.fullname }}</p>
        <p><em>Co-Authors:</em> {{ publication.co_authors }}</p>

        <template v-slot:modal-footer="{ ok, cancel, hide }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button @click="cancel()" size="md" variant="danger">
            Cancel
          </b-button>
          <b-button @click="updatePublication(publication)" size="md"
                    variant="primary"> Update
          </b-button>
          <b-button disabled size="md" variant="primary"> Delete</b-button>
        </template>
      </b-modal>

      <!-- PUBLICATION MODAL FOR UPDATE -->
      <PublicationModal></PublicationModal>
    </details>
  </div>
</template>

<script>
import {font_scale} from "@/utils/constants";
import EventBus from "@/components/EventBus";
import {
  getUserDashboardInfo,
  handleError, pageStartLoader,
  secureStoreGetAuthString,
  showFlashMessage
} from "@/utils/util_functions";
import PublicationModal from "@/components/PublicationModal";
import axios from "axios";
import {publication_resource} from "@/utils/api_paths";

export default {
  name: "UserPublications",

  components: {PublicationModal},

  data(){
      return {
        font_scale,
        response: {},
        publication: {},
        showPubModalView: false,
        time: 2000, // loader-time
      }
  },

  mounted() {
    EventBus.$on('created-user-dashboard', ()=> {
      this.response = getUserDashboardInfo()
    })
  },

  methods: {
    viewMyPublication(pubData) {
      this.publication = pubData
      this.showPubModalView = !this.showPubModalView
    },

    updatePublication(publication) {
      // updated data with required fields
      publication.sampleDataList = this.sampleDataList
      publication.fields = this.fields
      publication.user = this.response.fullname
      EventBus.$emit('update-publication', publication)
    },

    deletePublication(title) {
      let loader = pageStartLoader(this)
      axios.delete(publication_resource, {
        headers:
            {
              title: title,
              Authorization: secureStoreGetAuthString()
            }
      }).then((response) => {
          setTimeout(()=>{
            loader.hide(); this.getPublication();
            showFlashMessage(this, 'success', response.data['message'], '');
          }, this.time)
      }).catch((error) => { handleError(this, error, loader) });
    },

    downloadPublication(title){
      // todo: feature coming up soon
      return title
    }
  }
}
</script>